import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 23 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M14.598.75c1.567.262 3.093.728 4.538 1.382 2.49 3.603 3.727 7.666 3.27 12.354a18.273 18.273 0 0 1-5.57 2.764c-.451-.6-.85-1.235-1.192-1.9a11.8 11.8 0 0 0 1.881-.89 6.533 6.533 0 0 1-.46-.342 13.203 13.203 0 0 1-11.13 0c-.149.113-.303.23-.46.343.598.35 1.226.647 1.877.887A13.305 13.305 0 0 1 6.16 17.25a18.344 18.344 0 0 1-5.567-2.765c-.389-4.043.39-8.144 3.262-12.35A18.538 18.538 0 0 1 8.397.75c.215.38.409.77.581 1.17a17.114 17.114 0 0 1 5.038 0c.173-.4.367-.79.582-1.17ZM5.864 9.825c0 1.199.896 2.173 1.982 2.173 1.085 0 1.96-.974 1.979-2.173.019-1.199-.87-2.182-1.983-2.182s-1.978.983-1.978 2.182Zm7.311 0c0 1.199.893 2.173 1.98 2.173 1.086 0 1.958-.974 1.978-2.173.018-1.199-.864-2.182-1.978-2.182-1.115 0-1.98.983-1.98 2.182Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }